export default __webpack_public_path__ + "static/media/PCOM.fe450f88.jpeg";